import { Locale, Path } from "@common/constans";
import { IGResponse } from "@common/models";
import { ICmsCountry } from "@common/models/CMS";
import { Culture, ILocale } from "@core/index";
import { apolloQuery, GET_LANGUAGE_BY_COUNTRY_CODE } from "@service/graphql";
import { loadCountryWithIp } from "./Geo";

export function addScriptToHeader(text: string) {
    const script = document.createElement('script');
    script.innerHTML = text;
    document.head.appendChild(script);
}

export function linkScriptToHeader(url: string, onload?: any, onerror?: any, async: boolean = true, defer: boolean = true) {
    const script = document.createElement('script');
    script.src = url;
    script.async = async;
    script.defer = defer;
    script.onload = onload;
    script.onerror = onerror;
    document.head.appendChild(script);
}

export function linkScriptToBody(url: string, async: boolean = true, defer: boolean = true) {
    const script = document.createElement('script');
    script.src = url;
    script.async = async;
    script.defer = defer;
    document.body.appendChild(script);
}

export const setDefaultAttribute = () => {
    const { code, dir } = Culture.getLocale();
    document.documentElement.setAttribute("lang", code);
    document.documentElement.setAttribute("dir", dir);
}

export const loadLocale = (code?: string, reload?: boolean, path?: string) => {
    let locale: ILocale = {} as ILocale;
    let dir = localStorage.getItem("dir");
    let selectedCode = localStorage.getItem("culture");
    const pathname = window.location.pathname.toLowerCase();
    if (code) {
        selectedCode = code;
    } else {
        // set culture setting from url
        if (window.location.href.includes(Path.Booking.ItineraryEn)) {
            selectedCode = Locale.en;
        } else if (pathname) {
            const cultures = Culture.getCultures();
            for (const key in cultures) {
                if (Object.prototype.hasOwnProperty.call(cultures, key)) {
                    const culture = cultures[key];
                    if ((pathname.length === 3 && pathname === `/${culture.locale.lang.toLowerCase()}`) || pathname.includes(`/${culture.locale.lang.toLowerCase()}/`))
                        selectedCode = culture.locale.code;
                }
            }
        }
    }

    try {
        if (selectedCode)
            locale = Culture.getLocale(selectedCode);
        else
            loadLangWithIp();
    } catch (e) {
        console.log(e);
    }
    // First time loaded
    if (!locale.code) {
        locale = Culture.getLocale(Locale.fa);
    }
    selectedCode = locale.code;
    dir = locale.dir;
    if (!window.location.href.includes(Path.Booking.ItineraryEn)) {
        localStorage.setItem("culture", selectedCode);
        localStorage.setItem("dir", dir);
    }
    Culture.setDefault(selectedCode);
    // reloading application
    if (reload)
        window.location.href = `${window.location.origin}/${locale.lang}${path ? path : window.location.pathname + window.location.search}`;
    else if (!Culture.findLang(pathname)) {
        window.history.pushState('', '', `${window.location.origin}/${locale.lang}${path ? path : window.location.pathname + window.location.search}`);
    }
}

export const loadLangWithIp = () => {
    loadCountryWithIp()
        .then(async (response) => {
            const pathname = window.location.pathname.toLowerCase();
            const txt = response;
            const countryCode = txt.split(";")[1];
            const country = await apolloQuery<IGResponse<ICmsCountry[]>>(GET_LANGUAGE_BY_COUNTRY_CODE, { query: GET_LANGUAGE_BY_COUNTRY_CODE, variables: { code: countryCode, } });
            const lang = country.data.country[0] && country.data.country[0].language?.toLowerCase();
            if (lang && lang !== Culture.findLang(pathname)) {
                loadLocale(Culture.getLocale(Locale[lang]).code, true, Path.Home)
            }
        })
}